import emptyListState from '@/img/empty-list-state.svg';
import styles from './empty-visits-section.module.css';
import clsx from 'clsx';
import { useMediaQuery } from '@/hooks/use-media-query';
import { Button } from '../button';
import { Section } from '../containers/section';
import { useTranslation } from '@/contexts/i18n-context';

interface EmptyVisitsSectionProps {
  showStartVisit?: boolean;
}

const translationBase = 'dashboard.emptyList';

export function EmptyVisitsSection({ showStartVisit = false }: EmptyVisitsSectionProps) {
  const { t } = useTranslation();

  const isMobile = useMediaQuery('--screen-md');

  return (
    <Section classNameSection={styles.emptyVisitSection}>
      <div className={styles.container}>
        <img src={emptyListState} alt={t(`${translationBase}.iconAlt`)} className={styles.icon} />
        <div className={styles.text}>
          <p className={clsx('bold', !isMobile && 'body-1')}>{t(`${translationBase}.title`)}</p>
          <p className={clsx(isMobile && 'body-3')}>{t(`${translationBase}.description`)}</p>
          {showStartVisit && (
            <Button
              className={styles.button}
              variant="outlined"
              size="M"
              as="a"
              to="/visit/policies-consent"
            >
              {t(`${translationBase}.startVisitButton`)}
            </Button>
          )}
        </div>
      </div>
    </Section>
  );
}
